import { Component, input } from '@angular/core';
import { BaseInputComponent } from './base/base-input.component';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { TranslateKeyPipe } from 'src/app/pipes/translate-key/translate-key.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [FormsModule, TranslateKeyPipe, CommonModule, CheckboxModule],
})
export class CheckboxInputComponent extends BaseInputComponent<boolean> {
  binary = input(true);
  trueValue = input<any>(true);
  falseValue = input<any>(false);

  constructor() {
    super();
  }

  onInputCheckBox(event: CheckboxChangeEvent): void {
    console.log('test chk', event);
    this.onInput(event.checked);
  }
}
